import { signInAnonymously } from "firebase/auth";
import { auth } from "../firebase/firebaseConfig";

// Public forms use an anonymous Firebase session. This preserves the guest
// experience while giving each visitor an isolated storage namespace.
export const ensureGuestSession = async () => {
    try {
        if (auth.currentUser) return auth.currentUser;
        const credential = await signInAnonymously(auth);
        return credential.user;
    } catch (error) {
        const secureSessionError = new Error(
            "Unable to start a secure checkout session. Please refresh the page and try again."
        );
        secureSessionError.cause = error;
        throw secureSessionError;
    }
};

export const authenticatedJson = async (url, body) => {
    const user = await ensureGuestSession();
    const token = await user.getIdToken(true);
    const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(body),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.error) throw new Error(data.error || "Request failed");
    return data;
};
